import { Row, Table } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { setModal } from '../../../../common/slices/commonSlice';
import { perProps } from '../../../../common/types/commonTypes';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import CommonTableHeader from '../../../../components/common/CommonTableHeader';
import LoadingIndicator, {
  loadingIndicator,
} from '../../../../components/common/spinner/LoadingIndicator';
import { useGetAllRoomTypesWithPaginationQuery } from '../endpoints/roomTypesEndpoints';
import RoomTypeAddModal from '../modals/RoomTypesAddModal';
import RoomTypesEditModal from '../modals/RoomTypesEditModal';
import { RoomTypeDataType } from '../types/roomTypesTypes';
import { columns } from '../utils/utils';

const RoomTypes = ({ permission }: perProps) => {
  const dispatch = useAppDispatch();

  const [editInfo, setEditInfo] = useState<RoomTypeDataType | null>(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  const showModal = () => {
    dispatch(setModal(true));
  };

  const {
    isLoading,
    data: roomTypes,
    refetch,
  } = useGetAllRoomTypesWithPaginationQuery(pagination, {
    selectFromResult: (cache) => {
      const data = cache.data?.data;
      const count = cache.data?.count;
      const dataToReturn: RoomTypeDataType[] = [];
      const roomTypeNameList: string[] = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          roomTypeNameList.push(element.rtype_name);
          dataToReturn.push({
            ...element,
            key: i + 1,
          });
        }
      }
      return { ...cache, data: { dataToReturn, roomTypeNameList, count } };
    },
  });

  return (
    <div>
      <BreadCrumb
        arrOfOption={['Configuration', 'Room Types']}
        refetch={refetch}
        reloaderSize='small'
      />
      <CommonTableHeader
        width
        align
        title='Room Types'
        modalTitle={editInfo ? 'Edit Room Type' : 'Add New Room Type'}
        button_text='Add New Room Type'
        permission={permission?.['create:any']}
        element={
          editInfo ? (
            <RoomTypesEditModal
              info={editInfo}
              roomTypeNameList={roomTypes.roomTypeNameList}
              setNull={setEditInfo}
            />
          ) : (
            <RoomTypeAddModal roomTypeNameList={roomTypes.roomTypeNameList} />
          )
        }
        setNull={setEditInfo}
      />
      <Row justify={'center'}>
        <Table
          size='small'
          style={{ width: 900 }}
          bordered
          pagination={
            roomTypes?.count !== undefined && roomTypes?.count < 20
              ? false
              : {
                ...pagination,
                total: roomTypes?.count,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '500'],
                onChange: handlePaginationChange,
              }
          }
          columns={columns({ setEditInfo, showModal, permission, pagination })}
          dataSource={roomTypes.dataToReturn}
          scroll={{ x: true }}
          loading={{ spinning: isLoading, indicator: loadingIndicator }}
        />
      </Row>
      {isLoading && <LoadingIndicator />}
    </div>
  );
};

export default RoomTypes;
